/**
 * LitCurrent backend origin. Override with REACT_APP_BACKEND_URL when needed.
 *
 * Named apiConfig.ts to avoid clashing with the src/config/ directory.
 */
function normalizeOrigin(url: string): string {
  return String(url || "").replace(/\/$/, "");
}

export const DEFAULT_LITPULSE_BACKEND_URL =
  "https://api.litpulse.coolify.zareinnovations.xyz";

/** Origin only (no /api). */
export const BACKEND_URL = normalizeOrigin(
  process.env.REACT_APP_BACKEND_URL || DEFAULT_LITPULSE_BACKEND_URL
);

/** Base path for API client. */
export const API_BASE_URL = `${BACKEND_URL}/api`;

/**
 * LitBridge federated search — embedded in LitPortal.
 * Override with REACT_APP_FEDERATED_SEARCH_URL for local Next dev (e.g. http://localhost:3001).
 */
export const FEDERATED_SEARCH_APP_URL = normalizeOrigin(
  process.env.REACT_APP_FEDERATED_SEARCH_URL ||
    "https://lit-bridge.vercel.app"
);
